/**
 * TypeScript class for the search box shortcode component.
 */

export class SearchBox {
  private searchBoxContainer = document.querySelector(".dt-search-box");
  private input_query = document.getElementById("job-title") as HTMLInputElement;
  private input_location = document.getElementById("job-location") as HTMLInputElement;

  private joboverview_page_url = "" as string;

  private joboverview_page_btn_link = document.querySelector(
    ".dt-search-box .to-joboverview-page-btn"
  ) as HTMLAnchorElement;

  // PARAMS
  private queryParams = "";
  private locationParams = "";

  constructor() {
    if (!this.searchBoxContainer) {
      return;
    }

    if (!this.input_query && this.input_location) {
      console.warn("SearchBox: No input elements found");
      return;
    }

    if (!this.joboverview_page_btn_link) {
      console.warn("SearchBox: No button element found");
      return;
    } else {
      console.log("btn link:", this.joboverview_page_btn_link);
    }

    this.joboverview_page_url = this.joboverview_page_btn_link.href;

    this.init();
  }

  init() {
    // INPUT EVENTS
    this.input_query?.addEventListener("input", () => {
      this.queryParams = this.input_query?.value;
      this.updateUrl();
    });

    this.input_location?.addEventListener("input", () => {
      this.locationParams = this.input_location?.value;
      this.updateUrl();
    });

    // ENTER KEY EVENT
    // If Enter is pressed, the search should be performed (customer request)
    this.input_query?.addEventListener("keydown", (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        e.preventDefault();
        this.joboverview_page_btn_link.click();
      }
    });
    this.input_location?.addEventListener("keydown", (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        e.preventDefault();
        this.joboverview_page_btn_link.click();
      }
    });
  }

  /**
   * Updates the url link of the button to the job overview page.
   */
  updateUrl() {
    console.log(
      "update url to " + this.joboverview_page_url + "?title=" + this.queryParams + "&location=" + this.locationParams
    );
    this.joboverview_page_btn_link.href = `${this.joboverview_page_url}?title=${this.queryParams}&location=${this.locationParams}`;
  }
}
